import { ASSIGNMENT_TYPES } from "@/schemas/structure-assignment";
import { useParams } from "react-router-dom";

export const useStructureAssignmentsParams = () => {
  const { supervisorId, assignmentType } = useParams() as {
    supervisorId: string;
    assignmentType: ASSIGNMENT_TYPES;
  };
  return { supervisorId, assignmentType };
};
